<template>
  <nav
    role="navigation"
    class="c-mobile-nav"
  >
    <button
      type="button"
      class="c-mobile-nav__burger"
      tabindex="1"
      @click="showMenu"
    >
      <span>Menu</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="26px"
        height="21px"
        viewBox="0 0 26 21"
        version="1.1"
        aria-hidden="true"
      >

        <title>B034BF90-1DE4-4A8E-9021-3AF434D03E7D</title>

        <g
          id="Navigation"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g
            id="M-Nav-Home"
            transform="translate(-19.000000, -62.000000)"
            fill="#022840"
            fill-rule="nonzero"
          >
            <g
              id="Header-Nav"
              transform="translate(0.000000, 44.000000)"
            >
              <g
                id="$ICON/Menu"
                transform="translate(19.000000, 18.000000)"
              >
                <g id="Shape">
                  <path d="M1.36842105,0 C0.612676316,0 0,0.606561095 0,1.35483827 C0,2.10311545 0.612676316,2.70967655 1.36842105,2.70967655 L24.6315789,2.70967655 C25.3873237,2.70967655 26,2.10311545 26,1.35483827 C26,0.606561095 25.3873237,0 24.6315789,0 L1.36842105,0 Z M1.36842105,9.14515834 C0.612676316,9.14515834 0,9.75172621 0,10.5000034 C0,11.2482806 0.612676316,11.8548417 1.36842105,11.8548417 L24.6315789,11.8548417 C25.3873237,11.8548417 26,11.2482806 26,10.5000034 C26,9.75172621 25.3873237,9.14515834 24.6315789,9.14515834 L1.36842105,9.14515834 Z M1.36842105,18.2903235 C0.612676316,18.2903235 0,18.8968845 0,19.6451617 C0,20.3934389 0.612676316,21 1.36842105,21 L24.6315789,21 C25.3873237,21 26,20.3934389 26,19.6451617 C26,18.8968845 25.3873237,18.2903235 24.6315789,18.2903235 L1.36842105,18.2903235 Z" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </button>
    <slot name="search" />
    <div
      class="c-mobile-nav__slide u-background-color-base j-mobile-nav__slide"
      :class="{'c-mobile-nav__slide--showing': showMobile}"
    >
      <nav-close-btn
        class="c-mobile-nav__close"
        @click="hideMenu"
      />
      <button
        class="c-mobile-nav__back t-heading-6"
        :class="{'c-mobile-nav__back--showing':openId !== null}"
        type="button"
        tabindex="3"
        @click="closeSubMenu"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="21px"
          height="11px"
          viewBox="0 0 21 11"
          version="1.1"
        >

          <title>1D66B10C-A8FB-4B24-BA32-369414E91D93</title>

          <g
            id="Navigation"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g
              id="M-Nav"
              transform="translate(-320.000000, -77.000000)"
              fill="#022840"
              fill-rule="nonzero"
            >
              <g
                id="Arrow-Right"
                transform="translate(320.000000, 77.000000)"
              >
                <g
                  id="noun_Right-Arrow_2700696"
                  transform="translate(0.000000, 0.076923)"
                >
                  <path
                    id="Combined-Shape"
                    d="M18.0910562,6.00042517 L0.721153846,6.00042517 C0.322871575,6.00042517 0,5.71251305 0,5.35735544 C0,5.00219784 0.322871575,4.71428571 0.721153846,4.71428571 L18.2689263,4.71428571 L13.224647,1.2398162 C12.8854672,1.00605796 12.8230158,0.571371606 13.0851579,0.268917064 C13.3473,-0.0335374794 13.8347677,-0.0892268337 14.1739475,0.144531409 L20.6950612,4.63623559 C20.9250308,4.79269069 21.0352639,5.04771674 20.990008,5.29620264 C20.9910851,5.30213973 20.9920775,5.30809957 20.9929844,5.31408102 C21.0301597,5.55928431 20.9178127,5.80354686 20.6982634,5.95485733 L14.1730355,10.4493954 C14.0361345,10.5425556 13.8683514,10.5924277 13.6961472,10.5911703 C13.3651728,10.5902311 13.0713342,10.4020891 12.9645725,10.1227262 C12.8578108,9.84336323 12.9616634,9.53436948 13.2231361,9.35341955 L18.0910562,6.00042517 Z"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
        Go Back
      </button>
      <template v-for="(navItem, index) in mainNav">
        <nav-item
          :key="'c-mobile-nav__item_' + index"
          :ref="'j-mobile-nav__item_' + index"
          :item="navItem"
          :is-mobile="isMobile"
          :my-index="index"
          :tabindex-start="mainNav.length+3"
        />
      </template>
      <template v-if="findYourRing">
        <nav-card
          v-if="!findYourRing.featured"
          :nav-item="findYourRing"
          :is-mobile="isMobile"
          :tabindex="mainNav.length+maxIndexGap+4"
        />
        <nav-card-featured
          v-else
          :nav-item="findYourRing"
          :tabindex="mainNav.length+maxIndexGap+4"
        />
      </template>

      <mobile-utility-nav :tabindex-start="mainNav.length+maxIndexGap+5">
        <slot
          v-for="(_, name) in $slots"
          :slot="name"
          :name="name"
        />
      </mobile-utility-nav>
      <mobile-footer-nav
        :tabindex-start="mainNav.length+maxIndexGap+8"
        :footer-nav="footerNav"
      />
      <div
        v-if="$slots.footer"
        class="u-text-align-center"
      >
        <slot name="footer" />
      </div>
    </div>
  </nav>
</template>

<script>
import NavItem from "./NavItem";
import NavCard from "./NavCard";
import NavCardFeatured from "./NavCardFeatured";
import MobileUtilityNav from "./MobileUtilityNav";
import MobileFooterNav from "./MobileFooterNav";
import NavCloseBtn from "./NavCloseBtn";
export default {
  name: "MobileNav",
  components: {MobileFooterNav, MobileUtilityNav, NavCard, NavCardFeatured, NavItem, NavCloseBtn},
  props: {
    isMobile: {
      type: Boolean,
      default: true
    },
    openId: {
      type: Number,
      default: null
    },
    mainNav: {
      type: Array,
      default: null
    },
    footerNav: {
      type: Object,
      default: null
    },
    findYourRing: {
      type: Object,
      default: null
    },
  },
  data: function(){
    return {
      winWidth: 0,
      showMobile: false,
      navItemComponents: [],
    };
  },
  computed:{
    maxIndexGap: {
      get: function(){
        let high = 0;
        for(let i = 0; i < this.mainNav.length;++i){
          let testHigh = 0;
          if(this.mainNav[i].navItems) {
            testHigh += this.mainNav[i].navItems.length;
          }
          if(this.mainNav[i].secondaryNavItems){
            testHigh += this.mainNav[i].secondaryNavItems.length;
          }
          if(testHigh > high){
            high = testHigh;
          }
        }
        return high;
      }
    }
  },
  watch:{
    openId(){
      this.cleanSlider();
    },
    $route(){
      this.hideMenu();
    }
  },
  destroyed() {

  },
  mounted(){
    this.$nextTick(() => {
      if(this.openId !== null){
        if(this.isMobile){
          this.showMobile = true;
        }
        if(this.$refs["j-mobile-nav__item_" + this.openId]){
          this.$refs["j-mobile-nav__item_" + this.openId][0].showSubMenu();
        }
      }
      this.cleanSlider();
    });
  },
  methods: {
    showMenu(){
      this.showMobile = true;
      this.disableOutsideScrolling();
    },
    hideMenu(){
      this.showMobile = false;
      this.enableOutsideScrolling();
      this.closeOtherMenus();
    },
    closeSubMenu(){
      this.closeOtherMenus();
    },
    closeOtherMenus(notThisId = null){
      this.$parent.closeOtherMenus(notThisId);
      for(let i = 0; i < this.mainNav.length;++i){
        if(i !== notThisId){
          if(this.$refs["j-mobile-nav__item_" + i]){
            this.$refs["j-mobile-nav__item_" + i][0].hideSubMenu();
          }
        }
      }
    },
    clearOpen(id){
      this.$parent.clearOpen(id);
    },
    cleanSlider(){
      /*let sliders = this.$el.getElementsByClassName("j-mobile-nav__slide");
      if(sliders && sliders.length > 0){
        if(this.openId !== null){
          sliders[0].scrollTo(0,0);
          sliders[0].style["overflow-y"] = "hidden";
        } else {
          sliders[0].style["overflow-y"] = null; //reset to standard css
        }
      }*/
    },
    disableOutsideScrolling(){
      document.body.style["overflow-y"] = "hidden";
    },
    enableOutsideScrolling(){
      document.body.style["overflow-y"] = null;
    },
  }
}
</script>
<style lang="scss" scoped>
  .c-mobile-nav{
    &__slide{
      position: fixed;
      right: 103%;
      top: 0;
      opacity: 0;
      transition: right 0.3s, opacity 0.2s;
      width: 100%;
      height: 100%;
      overflow-y: auto;
      z-index: $zindex-global-header;
      padding: rem(20px) 0;

      &--showing{
        opacity: 1;
        right: 0;
      }
    }

    &__burger{
      @include buttonReset;
      margin-right: rem(15px);

      span{
        position: absolute;
        clip: rect(1px, 1px, 1px, 1px);
        padding: 0;
        border: 0;
        height: 1px;
        width: 1px;
        overflow: hidden;
      }
    }

    &__close{
      @include buttonReset;
      margin-left: rem(20px);
    }

    &__back{
      @include buttonReset;
      @include themify($themes) {
        background: themed('background', 'base');
      }
      position: fixed;
      left: 103%;
      top: 6px;
      opacity: 0;
      transition: left 0.3s, opacity 0.2s;
      padding: $filter-padding;
      width: 100%;
      text-align: left;

      &--showing{
        opacity: 1;
        left: rem(50px);
      }

      svg{
        transform: rotate(180deg);
        margin-right: 15px;
      }
    }


  }
</style>
